import dayjs from 'dayjs';

export const validateStep2 = (formData: any) => {
    const errors: Record<string, string> = {};

    if (Array.isArray(formData.avisosObraActividadesEspeciales)) {
        formData.avisosObraActividadesEspeciales.forEach((act: any) => {
            if ([1, 2, 3, 4].includes(act.idActividad)) {
                const start = act.fechaInicio ? dayjs(act.fechaInicio) : null;
                const end = act.fechaFin ? dayjs(act.fechaFin) : null;

                if (!start) {
                    errors[`actividad_${act.idActividad}_inicio`] =
                        'Debe completar la fecha de inicio.';
                }
                if (!end) {
                    errors[`actividad_${act.idActividad}_fin`] = 'Debe completar la fecha de fin.';
                }

                if (start && end) {
                    if (end.isBefore(start)) {
                        errors[`actividad_${act.idActividad}_fin`] =
                            'La fecha de fin no puede ser anterior a la de inicio.';
                    }

                    if (formData.fechaInicio && start.isBefore(dayjs(formData.fechaInicio))) {
                        errors[`actividad_${act.idActividad}_inicio`] =
                            'La fecha de inicio está fuera del rango de la obra.';
                    }

                    if (formData.fechaFin && end.isAfter(dayjs(formData.fechaFin))) {
                        errors[`actividad_${act.idActividad}_fin`] =
                            'La fecha de fin está fuera del rango de la obra.';
                    }
                }
            }

            if (act.idActividad === 18) {
                if (!formData.descripcionActividad?.trim()) {
                    errors['descripcionActividad'] = 'Debe completar la descripción.';
                }
            }
        });
    }

    if (
        !Array.isArray(formData.avisosObraTiposSubtipos) ||
        formData.avisosObraTiposSubtipos.length === 0
    ) {
        errors['tiposObra'] = 'Debe seleccionar al menos un tipo de obra.';
    }

    return errors;
};
